import { ITaxState } from '../../types/taxes/taxesTypes';
import endpoints from '../../utils/commonVariables/endpoints';
import {
    savableEntities,
    viewModelEntities,
} from '../../utils/commonVariables/entityKeys';
import convertToOvariant from '../../utils/convertToOvariant';
import { supplierTaxViewModelStructure } from '../../utils/viewModelStructures/supplierTax';
import api from '../api';
import { adaptTaxToDDBB } from './taxesAdapters';

export const getTaxData = async (id: string) => {
    const endpoint = endpoints.viewModel(viewModelEntities.SupplierTax, id);
    return api.post(endpoint, supplierTaxViewModelStructure);
};

export const saveTaxToDDBB = async (taxData: ITaxState) => {
    const taxToDDBB = adaptTaxToDDBB(taxData);
    const objectToSend = convertToOvariant(
        savableEntities.SupplierTax,
        taxToDDBB,
        taxToDDBB.Id,
        supplierTaxViewModelStructure
    );
    return api.post(endpoints.commonSave, objectToSend);
};
